import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '../../../services/notification.service';
import { User } from '../../../classes/user';
import { CustomValidators } from '../../../validators/custom-validators';
import { BaseService } from '../../../services/base.service';
import { PopupService } from '../../../services/popup.service';
import { UserService } from '../../../services/user.service';
import { Subscription, Subject } from "rxjs";

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class PasswordResetComponent implements OnInit {

  public requestId: string;
  public retypePassword: string;
  public isLoggedInUserChangePassword: boolean = false;
  resetPasswordForm: FormGroup;
  user = new User();
  routerEventsSubscription: Subscription;
  isResetting: boolean = false;
  submitted: boolean = false;
  inputChangeListener: Subject<any> = new Subject<any>();

  constructor(public userService: UserService, public router: Router,
              public route: ActivatedRoute, public formBuilder: FormBuilder,
              public notificationService: NotificationService, public popupService: PopupService,
              public ref: ChangeDetectorRef, public baseService: BaseService) {
    this.inputChangeListener
      .subscribe((data)=> {
        this.ref.detectChanges();
      });
  }

  ngOnInit() {
    this.resetPasswordForm = this.formBuilder.group({
      password: [this.user.password, Validators.compose([Validators.required, Validators.minLength(6), Validators.pattern('^(?=.*[0-9])(?=.*[a-zA-Z]).{6,50}$')])],
      retypePassword: [this.retypePassword, Validators.compose([Validators.required, Validators.minLength(6)])]
    }, { validator: CustomValidators.matchingPasswords('password', 'retypePassword') });
    this.onRouteChange();
  }

  ngAfterContentChecked() {
    this.ref.detectChanges();
  }

  onRouteChange() {
    this.routerEventsSubscription = this.baseService.paramChangeStream.subscribe(value => {
      if(value) {
        this.checkIfParamsAvailable();
      }
    });
  }

  checkIfParamsAvailable() {
    let queryParams = this.route.snapshot.queryParams;
    if(queryParams['requestId']) {
       this.requestId = decodeURIComponent(queryParams['requestId']);
    } else if(queryParams['passwordChange']) {
      this.isLoggedInUserChangePassword = (decodeURIComponent(queryParams['passwordChange']) === 'true');
    }
    this.ref.detectChanges();
  }

  onSubmit() {
    this.submitted = true;
    if(this.resetPasswordForm.valid) {
      this.isResetting = true;
      this.userService.resetPassword(this.user, this.requestId, this.isLoggedInUserChangePassword).subscribe((result) => {
        if (result) {
          this.isResetting = false;
          this.submitted = false;
          this.closeModal();
          if(!this.userService.getLoggedIn()) {
            this.router.navigate(['/map/log-in'],{
              preserveQueryParams: false,
              replaceUrl: true
            });
          } else {
            this.router.navigate(['/map'],{
              preserveQueryParams: false,
              replaceUrl: true
            });
          }
          this.notificationService.info('Your password has been reset.');
        }
      },(error)=> {
        this.isResetting = false;
      });
    } else {
      this.ref.detectChanges();
    }
  }

  closeModal() {
    this.resetPasswordForm.reset();
    this.submitted = false;
    this.isLoggedInUserChangePassword = false;
    this.requestId = null;
    this.router.navigate(['/map'],{
      preserveQueryParams: false,
      replaceUrl: true
    });
  }

  ngOnDestroy() {
    this.routerEventsSubscription && this.routerEventsSubscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/password-recovery/password-reset/password-reset.component.ts